import Checkbox from '../common/Checkbox';

export const AddSongActionOptions = ({
  fitSongToVideo,
  setFitSongToVideo,
  disabled,
}: {
  fitSongToVideo: boolean;
  setFitSongToVideo: (fitSongToVideo: boolean) => void;
  disabled?: boolean;
}) => {
  const color = fitSongToVideo ? 'var(--primary)' : 'var(--background)';
  const borderColor = fitSongToVideo ? 'var(--primary)' : 'var(--border)';
  const toggleFitSongToVideo = () => {
    setFitSongToVideo(!fitSongToVideo);
  };

  return (
    <Checkbox
      label="Fit song to end of video"
      color={color}
      borderColor={borderColor}
      onClick={toggleFitSongToVideo}
      checked={fitSongToVideo}
      disabled={disabled}
      overrides={{
        containerStyles: { 'margin-top': '8px', gap: '10px' },
      }}
    />
  );
};

export default AddSongActionOptions;
